// @ts-strict-ignore
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { SafeStyle, DomSanitizer } from '@angular/platform-browser';
import { sectorToString } from '../../../../functions/sector-to-string';
import { Sector } from '../../../../model/sector';

@Component({
    selector: 'app-target-barometer',
    templateUrl: './target-barometer.component.html',
    styleUrls: ['./target-barometer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TargetBarometerComponent {
  @Input() sector: Sector;
  @Input() set value(v: number | undefined) {
    if (v !== undefined) {
      v = v < -100 ? -100 : v > 100 ? 100 : v;
    }
    this._value = v;
  }

  private _value: number | undefined;

  get pointerClass(): string {
    let cls = 'pointer';
    if (this._value === undefined) {
      cls += ' unset';
    }
    return cls;
  }

  get pointerImage(): string {
    let img = 'barometer-pointer';
    if (this._value === undefined) {
      img = 'barometer-centre.gray';
    }
    return `/assets/images/board/${img}.svg`;
  }

  get pointerTransform(): SafeStyle {
    const rotation = this._getRotation(this._value);
    const transform = `translateX(-50%) rotate(${rotation}deg) `;
    return this.sanitizer.bypassSecurityTrustStyle(transform);
  }

  get scaleImage(): string {
    let sector = sectorToString(this.sector);
    if (this._value === undefined) {
      sector = 'undefined';
    }
    return `/assets/images/board/barometer.${sector}.svg`;
  }

  constructor(private sanitizer: DomSanitizer) {}

  private _getRotation(value: number): number {
    if (value === undefined || value <= -100) {
      return 0;
    }
    if (value >= 100) {
      return 180;
    }
    return ((value + 100) / 200) * 180;
  }
}
